const getCoursePrefix = (courseId: string | number) => `-course-${courseId}`
const getModulePrefix = (moduleId?: string | number) => (moduleId ? `-module-${moduleId}` : '')
const getUnitPrefix = (unitId?: string | number) => (unitId ? `-unit-${unitId}` : '')
const getBlockPrefix = (blockIdent?: string | number) => (blockIdent ? `-block-${blockIdent}` : '')

function buildCacheKey(key: string) {
  return ({
    courseId,
    moduleId,
    unitId,
    blockIdent,
  }: {
    courseId: string | number
    moduleId?: string | number
    unitId?: string | number
    blockIdent?: string | number
  }) =>
    key +
    getCoursePrefix(courseId) +
    getModulePrefix(moduleId) +
    getUnitPrefix(unitId) +
    getBlockPrefix(blockIdent)
}

export const CACHE_KEYS = {
  COURSE: getCoursePrefix,
  MODULE: getModulePrefix,
  UNIT: getUnitPrefix,
  BLOCK: getBlockPrefix,
  BLOCK_PROGRESS: buildCacheKey('block-progress'),
  NEXT_BLOCK: buildCacheKey('next-block'),
  OBJECTIVE_PROGRESS: buildCacheKey('objective-progress'),
  BOOKMARK: buildCacheKey('bookmark'),
  COURSE_UNIT_TIME_PROGRESS: buildCacheKey('course-unit-time-progress'),
}
